import React from 'react';

const Pagination = ({
    currentPage,
    totalPages,
    onPageChange,
    maxPagesToShow = 5
}) => {
    if (totalPages <= 1) return null;

    const pages = [];

    // SVGs para as setas
    const ArrowLeft = (
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 7H1.5M1.5 7L7.5 1M1.5 7L7.5 13" stroke="#37428E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const ArrowRight = (
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 7H17.5M17.5 7L11.5 1M17.5 7L11.5 13" stroke="#37428E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const ArrowDoubleLeft = (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M15 19L8 12L15 5" stroke="#37428E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19 19L12 12L19 5" stroke="#37428E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    const ArrowDoubleRight = (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M9 5L16 12L9 19" stroke="#37428E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 5L12 12L5 19" stroke="#37428E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    // Função para adicionar botão de página
    const addPage = (page) => {
        pages.push(
            <button
                key={page}
                onClick={() => onPageChange(page)}
                disabled={page === currentPage}
                className={`pagination-number${page === currentPage ? ' selected' : ''}`}
                style={{
                    margin: '0 5px',
                    padding: '5px 12px',
                    border: 'none',
                    borderRadius: '6px',
                    background: page === currentPage ? '#F0F0F0' : 'transparent',
                    color: page === currentPage ? '#3C3C3C' : '#818181',
                    fontWeight: page === currentPage ? 'bold' : 'normal',
                    cursor: page === currentPage ? 'default' : 'pointer',
                    transition: 'background 0.2s'
                }}
            >
                {page}
            </button>
        );
    };

    // Botão para primeira página (dupla seta)
    pages.push(
        <button
            key="first"
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
            className="pagination-arrow"
            style={{
                margin: '0 5px',
                padding: '5px 10px',
                border: '1.5px solid #F0F0F0',
                borderRadius: '6px',
                background: 'transparent',
                color: '#37428E',
                fontSize: '18px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
            }}
            aria-label="Primeira página"
        >
            {ArrowDoubleLeft}
        </button>
    );

    // Botão para página anterior (seta simples)
    pages.push(
        <button
            key="prev"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-arrow"
            style={{
                margin: '0 5px',
                padding: '5px 10px',
                border: '1.5px solid #F0F0F0',
                borderRadius: '6px',
                background: 'transparent',
                color: '#37428E',
                fontSize: '18px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
            }}
            aria-label="Página anterior"
        >
            {ArrowLeft}
        </button>
    );

    // Lógica para mostrar as páginas
    if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) addPage(i);
    } else {
        if (currentPage <= 3) {
            for (let i = 1; i <= 4; i++) addPage(i);
            pages.push(<span key="start-ellipsis" style={{ margin: '0 5px', color: '#818181' }}>...</span>);
            addPage(totalPages);
        } else if (currentPage >= totalPages - 2) {
            addPage(1);
            pages.push(<span key="end-ellipsis" style={{ margin: '0 5px', color: '#818181' }}>...</span>);
            for (let i = totalPages - 3; i <= totalPages; i++) addPage(i);
        } else {
            addPage(1);
            pages.push(<span key="mid-ellipsis-left" style={{ margin: '0 5px', color: '#818181' }}>...</span>);
            for (let i = currentPage - 1; i <= currentPage + 1; i++) addPage(i);
            pages.push(<span key="mid-ellipsis-right" style={{ margin: '0 5px', color: '#818181' }}>...</span>);
            addPage(totalPages);
        }
    }

    // Botão para próxima página (seta simples)
    pages.push(
        <button
            key="next"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-arrow"
            style={{
                margin: '0 5px',
                padding: '5px 10px',
                border: '1.5px solid #F0F0F0',
                borderRadius: '6px',
                background: 'transparent',
                color: '#37428E',
                fontSize: '18px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
            }}
            aria-label="Próxima página"
        >
            {ArrowRight}
        </button>
    );

    // Botão para última página (dupla seta)
    pages.push(
        <button
            key="last"
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="pagination-arrow"
            style={{
                margin: '0 5px',
                padding: '5px 10px',
                border: '1.5px solid #F0F0F0',
                borderRadius: '6px',
                background: 'transparent',
                color: '#37428E',
                fontSize: '18px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
            }}
            aria-label="Última página"
        >
            {ArrowDoubleRight}
        </button>
    );

    return (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
            {pages}
        </div>
    );
};

export default Pagination;